import {Controller} from "@hotwired/stimulus"
import {Turbo} from "@hotwired/turbo-rails"

// Connects to data-controller="task-status"
export default class extends Controller {
    static targets = ["toggleButton"]

    connect() {
        // Initialize controller
    }

    toggle(event) {
        // Prevent default form submission
        event.preventDefault()

        const button = event.currentTarget
        const taskId = button.dataset.taskId
        const completed = button.dataset.completed === "true"

        // Show loading state
        button.disabled = true

        // Send AJAX request to toggle task status
        fetch(`/hubs/tasks/${taskId}/toggle`, {
            method: "PATCH",
            headers: {
                "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
                "Content-Type": "application/json",
                "Accept": "text/vnd.turbo-stream.html"
            },
            body: JSON.stringify({completed: !completed})
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Network response was not ok")
                }
                return response.text()
            })
            .then(html => {
                // Process the Turbo Stream response
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, "text/html")
                const streamElement = doc.querySelector("turbo-stream")
                if (streamElement) {
                    Turbo.renderStreamMessage(html)
                }
                // Re-enable button after successful response
                button.disabled = false
            })
            .catch(error => {
                console.error("Error:", error)
                // Re-enable button on error
                button.disabled = false
            })
    }
}
